export default __webpack_public_path__ + "static/media/Ficha Técnica - Manga Organico.0e2ca625.pdf";